// import mt from '../../assets/muvtech/mt.png';
// import protection from '../../assets/muvtech/protection.png';
// import shield from '../../assets/muvtech/shield.png';
import { useNavigate } from 'react-router-dom';

function MuvtechCard({ item, type }) {
  const navigate = useNavigate();
  return (
    <div
      className="muvtech-card"
      onClick={() =>
        navigate(`/muvtech/products-list/details/${type}/${item.id}`)
      }
    >
      <div className="card-media">
        <img src={item.image[0]} alt="mt" />
      </div>
      <h3 className="item-name">{item.title}</h3>
      <h4 className="brand-name">{item.compatibleModels}</h4>
      <p className="price-tag">
        <strong>&#8377; {item.price}.00</strong>
        {/* <span> 2499</span> */}
      </p>
      {/* <div className="specs">
        <div className="specs-content">
          <img src={shield} alt="" />
          <p>8FT Drop Tested</p>
        </div>
        <div className="specs-content">
          <img src={protection} alt="" />
          <p>360 Protection</p>
        </div>
      </div> */}

      <button className="mt-button">View Product</button>
    </div>
  );
}

export default MuvtechCard;
